
/**
 * Utility functions for managing onboarding state in the database
 */

import { supabase } from '@/integrations/supabase/client';

/**
 * Check if onboarding is completed in the database
 */
export const checkDatabaseOnboardingStatus = async (userId?: string): Promise<boolean> => {
  if (!userId) return false;
  
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('onboarding_completed')
      .eq('id', userId)
      .single();
      
    if (error) {
      console.error("[ONBOARDING] Database error checking status:", error);
      return false;
    }
    
    return data?.onboarding_completed === true;
  } catch (err) {
    console.error("[ONBOARDING] Error checking database status:", err);
    return false;
  }
};

/**
 * Update onboarding completion status in the database
 */
export const updateDatabaseOnboardingStatus = async (userId?: string, completed: boolean = true): Promise<void> => {
  if (!userId) return;
  
  try {
    const { error } = await supabase
      .from('profiles')
      .update({ onboarding_completed: completed })
      .eq('id', userId);
      
    if (error) {
      console.error("[ONBOARDING] Error updating database status:", error);
    } else {
      console.log(`[ONBOARDING] Database status updated: ${completed}`);
    }
  } catch (err) {
    console.error("[ONBOARDING] Error updating database status:", err);
  }
};
